import { IconChevronRight, IconFilePlus, IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Banner, EmptyState, Spinner } from '@/components/common';
import { useResource } from '@/hooks';
import { errorMessage } from '@/lib/api-client';
import { navigate } from '@/lib/router';
import { formatDate } from '../chart/components';
import { consentsApi } from './api';

/** Consents given, newest first: search by number, patient or method, open to reprint. */
export function ConsentsPage() {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const [debounced, setDebounced] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(query.trim()), 250);
    return () => clearTimeout(timer);
  }, [query]);
  const consents = useResource(() => consentsApi.list({ q: debounced }), debounced);

  return (
    <div className="stack">
      <div className="page-head">
        <div className="page-head__title">
          <h1>{t('consents.title')}</h1>
        </div>
        <button
          type="button"
          className="btn btn--sm btn--primary"
          onClick={() => navigate({ name: 'consent', id: 'new' })}
        >
          <IconFilePlus size={18} /> {t('consents.new')}
        </button>
      </div>

      <div className="search">
        <IconSearch size={20} />
        <input
          className="input"
          type="search"
          placeholder={t('consents.searchPlaceholder')}
          aria-label={t('consents.searchPlaceholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {consents.error ? (
        <Banner
          tone="error"
          action={
            <button type="button" className="btn btn--sm" onClick={() => consents.reload()}>
              {t('common.retry')}
            </button>
          }
        >
          {errorMessage(consents.error)}
        </Banner>
      ) : !consents.data ? (
        <Spinner />
      ) : consents.data.length === 0 ? (
        <EmptyState>{debounced ? t('consents.noResults') : t('consents.empty')}</EmptyState>
      ) : (
        <section className="card" style={{ padding: '4px 12px' }}>
          <ul className="list">
            {consents.data.map((c) => (
              <li key={c.id}>
                <button
                  type="button"
                  className="list-item"
                  onClick={() => navigate({ name: 'consent', id: c.id })}
                >
                  <span className="offer-number">{c.number}</span>
                  <span className="grow">
                    <strong>
                      {c.patient.lastName} {c.patient.firstName}
                    </strong>
                    <span className="small muted" style={{ display: 'block' }}>
                      {formatDate(c.issuedAt)} · {c.methodName}
                    </span>
                  </span>
                  <IconChevronRight size={20} className="muted" />
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
